import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getInfo as n } from "./spatialReferenceUtils.js";

function t(n) {
  if (!n) return null;
  if (Array.isArray(n)) return n;
  var t = n.hasZ,
      e = n.hasM;
  if ("point" === n.type) return e && t ? [n.x, n.y, n.z, n.m] : t ? [n.x, n.y, n.z] : e ? [n.x, n.y, n.m] : [n.x, n.y];
  if ("polygon" === n.type) return n.rings.slice(0);
  if ("polyline" === n.type) return n.paths.slice(0);
  if ("multipoint" === n.type) return n.points.slice(0);

  if ("extent" === n.type) {
    var _t = n.clone().normalize();

    if (!_t) return null;

    var _e = !1,
        _r = !1;

    return _t.forEach(function (n) {
      n.hasZ && (_e = !0), n.hasM && (_r = !0);
    }), _t.map(function (n) {
      var t = [[n.xmin, n.ymin], [n.xmin, n.ymax], [n.xmax, n.ymax], [n.xmax, n.ymin], [n.xmin, n.ymin]];

      if (_e && n.hasZ) {
        var _e2 = .5 * (n.zmax - n.zmin);

        for (var _n = 0; _n < t.length; _n++) {
          t[_n].push(_e2);
        }
      }

      if (_r && n.hasM) {
        var _e3 = .5 * (n.mmax - n.mmin);

        for (var _n2 = 0; _n2 < t.length; _n2++) {
          t[_n2].push(_e3);
        }
      }

      return t;
    });
  }

  return null;
}

function e(n, t) {
  var e = t[0] - n[0],
      r = t[1] - n[1];

  if (n.length > 2 && t.length > 2) {
    var _o = n[2] - t[2];

    return Math.sqrt(e * e + r * r + _o * _o);
  }

  return Math.sqrt(e * e + r * r);
}

function r(n, t, e) {
  var r = n[0] + e * (t[0] - n[0]),
      o = n[1] + e * (t[1] - n[1]);
  return n.length > 2 && t.length > 2 ? [r, o, n[2] + e * (t[2] - n[2])] : [r, o];
}

function o(n, t, e, r) {
  var _t2 = _slicedToArray(t, 2),
      o = _t2[0],
      i = _t2[1],
      _e$r = _slicedToArray(e[r], 2),
      s = _e$r[0],
      l = _e$r[1],
      _e4 = _slicedToArray(e[r + 1], 2),
      f = _e4[0],
      u = _e4[1],
      h = f - s,
      c = u - l,
      a = h * h + c * c,
      g = (o - s) * h + (i - l) * c,
      m = Math.min(1, Math.max(0, g / a));

  return n[0] = s + h * m, n[1] = l + c * m, n;
}

function i(n, t) {
  return r(n, t, .5);
}

function s(n) {
  var t = n.length;
  var r = 0;

  for (var _o2 = 0; _o2 < t - 1; ++_o2) {
    r += e(n[_o2], n[_o2 + 1]);
  }

  return r;
}

function l(n, t) {
  if (t <= 0) return n[0];
  var o = n.length;
  var i = 0;

  for (var _s = 0; _s < o - 1; ++_s) {
    var _o3 = e(n[_s], n[_s + 1]);

    if (t - i < _o3) {
      var _e5 = (t - i) / _o3;

      return r(n[_s], n[_s + 1], _e5);
    }

    i += _o3;
  }

  return n[o - 1];
}

function f(n, t, e) {
  var r = n.length;
  var o = 0,
      i = 0,
      s = 0;

  for (var _l = 0; _l < r; _l++) {
    var _f = n[_l],
        _u = n[(_l + 1) % r];
    var _h = 2;
    o += _f[0] * _u[1] - _u[0] * _f[1], _f.length > 2 && _u.length > 2 && e && (i += _f[0] * _u[2] - _u[0] * _f[2], _h = 3), _f.length > _h && _u.length > _h && t && (s += _f[0] * _u[_h] - _u[0] * _f[_h]);
  }

  return o <= 0 && i <= 0 && s <= 0;
}

function u(n) {
  if ("rings" in n) {
    var _iterator = _createForOfIteratorHelper(n.rings),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t4 = _step.value;
        _t4.length < 3 || _t4[0][0] === _t4[_t4.length - 1][0] && _t4[0][1] === _t4[_t4.length - 1][1] || _t4.push([_t4[0][0], _t4[0][1]]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (n.rings.length > 0) {
      if (!f(n.rings[0], n.hasM, n.hasZ)) for (var _t3 = 0; _t3 < n.rings.length; ++_t3) {
        n.rings[_t3] = n.rings[_t3].reverse();
      }
    }
  }
}

function h(n) {
  if ("rings" in n) {
    var _iterator2 = _createForOfIteratorHelper(n.rings),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _t5 = _step2.value;
        _t5.length < 3 || _t5[0][0] === _t5[_t5.length - 1][0] && _t5[0][1] === _t5[_t5.length - 1][1] || _t5.push([_t5[0][0], _t5[0][1]]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
}

function c(n) {
  var t = n.length;
  var e = 0;

  for (var _r2 = 0; _r2 < t; _r2++) {
    var _o4 = n[_r2],
        _i = n[(_r2 + 1) % t];
    e += _o4[0] * _i[1] - _i[0] * _o4[1];
  }

  return e;
}

function a(n) {
  if ("polygon" !== n.type && "polyline" !== n.type) return n;
  return g("polygon" === n.type ? n.rings : n.paths, n.spatialReference), n;
}

function g(t, e) {
  var r = n(e);
  if (!r) return;
  var o = r.valid[0],
      i = r.valid[1],
      s = i - o;

  var _iterator3 = _createForOfIteratorHelper(t),
      _step3;

  try {
    var _loop = function _loop() {
      var n = _step3.value;
      var t = 1 / 0,
          e = -1 / 0;
      n.forEach(function (n) {
        var r = n[0];

        for (; r < o;) {
          r += s;
        }

        for (; r > i;) {
          r -= s;
        }

        t = Math.min(t, r), e = Math.max(e, r), n[0] = r;
      });
      var r = e - t;
      s - r < r && n.forEach(function (n) {
        n[0] < 0 && (n[0] += s);
      });
    };

    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}

function m(n, t, e, r) {
  var o = 1 / 0,
      i = -1 / 0;
  n.forEach(function (n) {
    var s = n.pos[0];

    for (; s < t;) {
      s += r;
    }

    for (; s > e;) {
      s -= r;
    }

    o = Math.min(o, s), i = Math.max(i, s), n.unnormalizedPos[0] = s, n.unnormalizedPos[1] = n.pos[1], n.pos.length > 2 && (n.unnormalizedPos[2] = n.pos[2]), n.pos.length > 3 && (n.unnormalizedPos[3] = n.pos[3]);
  });
  var s = i - o;
  r - s < s && n.forEach(function (n) {
    n.unnormalizedPos[0] < 0 && (n.unnormalizedPos[0] += r);
  });
}

export { h as closeRings, u as closeRingsAndFixWinding, m as computeUnnormalizedVertexPositionsOnDateLineCrossing, t as geometryToCoordinates, e as getLength, i as getMidpoint, s as getPathLength, l as getPointOnPath, c as getRingArea, f as isClockwise, o as projectPointOnLine, a as unnormalizeGeometryOnDatelineCrossing, g as unnormalizeVerticesOnDatelineCrossing };